module.exports = "<input ng-model=query ng-change=loadItems(query) type=search placeholder=\"{{ 'jdro_common.find' | translate }}\" class=form-control ng-model-options=inputOptions?inputOptions:{} id=find-input /> ";


//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/directives/layout/tableInputFind.html
// module id = 371
// module chunks = 0